'use strict';

CNT.ngModule.run(['$rootScope', '$state', '$stateParams','gettextCatalog','T3_CabeceraPresentacionService', 'T3_TrazaService',
    function($rootScope, $state, $stateParams, gettextCatalog, T3_CabeceraPresentacionService, T3_TrazaService) {
		
		//TODO Auto-generated file

        T3_CabeceraPresentacionService.initializeHead(CNT.name);
        var actualLocalLanguageStorage = T3_CabeceraPresentacionService.getLanguage();
        gettextCatalog.currentLanguage = actualLocalLanguageStorage;

        T3_COMUN_APP.LANGFILES.push("cgt/accessUserPass/lang/accessUserPass_es_ES.json");
        gettextCatalog.setStrings('es_ES', require("@telefonica/segu.cgt-AccessUserPass/src/accessUserPass/lang/accessUserPass_es_ES.json"));
    }
]);

CNT.ngModule.config(['$stateProvider', '$urlRouterProvider', '$ocLazyLoadProvider','T3_UrlServiceProvider',
    function($stateProvider, $urlRouterProvider, $ocLazyLoadProvider,T3_UrlServiceProvider) {

    	$ocLazyLoadProvider.config({
    		loadedModules: ['ui.bootstrap',T3_COMUN_APP.NAME]
    	});

        $urlRouterProvider.otherwise('/accessUserPass');
		$stateProvider.state('accessUserPass', {

			url: '/accessUserPass',
			params: {
			    cgtAccessUserPassIn: {
					"idCustomer":"NOVUM"
				}
			},
			template: require('@telefonica/segu.cgt-AccessUserPass/src/accessUserPass/accessUserPass_view.html'),
			resolve: {
			    loadMyCtrl: ['$ocLazyLoad','T3_UrlService', function($ocLazyLoad,T3_UrlService) {
			        return function (){
								var resolver = function(){};
							
								var promise = new Promise(function (resolve) {
									resolver = resolve;
								});

								require.ensure([], function () {
										
										T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-AccessUserPass/src/accessUserPass/', false, /^.*_(constant|controller|directive|service|model).js$/));
										T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-VerifyOtpMobileAccess/src/verifyOtpMobileAccess/', false, /^.*_(constant|controller|directive|service|model).js$/));
 

									$ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
									resolver($ocLazyLoad.load({ name: CNT.name }));
								});					
								return promise;

							}();
			    }]
			}
		}).state('savePassword', {

			url: '/savePassword',
			params: {
			    cgtSavePasswordIn: null
			},
			template: require('@telefonica/segu.cgt-SavePassword/src/savePassword/savePassword_view.html'),
			resolve: {
			    loadMyCtrl: ['$ocLazyLoad','T3_UrlService', function($ocLazyLoad,T3_UrlService) {
			        return function (){
								var resolver = function(){};
							
								var promise = new Promise(function (resolve) {
									resolver = resolve;
								});

								require.ensure([], function () {
										
										T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-SavePassword/src/savePassword/', false, /^.*_(constant|controller|directive|service|model).js$/));
 

									$ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
									resolver($ocLazyLoad.load({ name: CNT.name }));
								});					
								return promise;

							}();
			    }]
			}
		}).state('contactMedium', {

			url: '/contactMedium',
			params: {
			    cgtSavePasswordIn: null
			},
			template: require('@telefonica/segu.cgt-ContactMedium/src/contactMedium/contactMedium_view.html'),
			resolve: {
			    loadMyCtrl: ['$ocLazyLoad','T3_UrlService', function($ocLazyLoad,T3_UrlService) {
			        return function (){
								var resolver = function(){};
							
								var promise = new Promise(function (resolve) {
									resolver = resolve;
								});

								require.ensure([], function () {
										
										T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-ContactMedium/src/contactMedium/', false, /^.*_(constant|controller|directive|service|model).js$/));

										T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-VerifyOTP/src/verifyOTP/', false, /^.*_(constant|controller|directive|service|model).js$/));

									$ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
									resolver($ocLazyLoad.load({ name: CNT.name }));
								});					
								return promise;

							}();
			    }]
			}
		});
}]);